// 多語言標籤：zh_CN.js
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'

const zhCN = {
  ...zhCNLocale,
  PUB: {
    lyods: '莱斯工程有限公司',
    home: '首页',
    name: '名称',
    lang: '语言',
    admin: '系统管理员',
    login: '登录',
    tenantId: '租户号',
    userRole: '用户角色',
    reLogin: '重新登录',
    logining: '登录中...',
    logout: '退出登录',
    logoutTips: '确定注销并退出系统吗？',
    loginName: '登录名称',
    password: '密码',
    resetPwd: '重置密码',
    code: '验证码',
    retrieve: '找回密码',
    copyright: '版权所有',
    rememberMe: '记住我',
    fogertPwd: '忘记密码',
    cancelMail: '取消所有邮件',
    loading: '加载中...',
    inputContent: '请输入内容',
    pleSelect: '请选择',
    pleMultiSelect: '多个值，以“,”分隔',
    inputMultiContent: '多个值，分隔为：',
    selectDate: '选择日期',
    selectTime: '选择时间',
    selectDateTime: '选择日期时间',
    ok: '确定',
    cancel: '取消',
    return: '返回',
    tips: '提示',
    sysTips: '系统提示',
    person: '个人中心',
    layout: '布局设置',
    layoutSize: '布局大小',
    search: '查询',
    add: '新增',
    upd: '修改',
    del: '删除',
    view: '查看',
    copy: '复制',
    imp: '导入',
    exp: '导出',
    auth: '授权',
    nonselected: '请先选择要操作的记录',
    warn: '警告',
    confirmDelete: '确认删除此记录?',
    confirmSession: "此记录为当前用户，确认继续删除？",
    cancelOper: '已取消当前操作',
    confirmPwd: '确认密码',
    email: '电子邮箱',
    phone: '电话',
    mobile: '手机',
    fax: '传真',
    address: '地址',
    status: '状态',
    normal: '正常',
    invalid: '作废',
    checkAll: '全选',
    field: '字段',
    oper: '比较符',
    searchVal: '条件值',
    action: '操作',
    sort: '排序',
    unit: '部门',
    unitGrp: '部门组',
    refresh: '刷新页面',
    closeOth: '关闭其他',
    closeCurr: '关闭当前',
    closeAll: '关闭所有',
    show: '显示',
    fixed: '固定',
    open: '开启',
    sysLayout: '系统布局配置',
    themeColor: '主题颜色',
    reset: '重置',
    oldPwd: '原密码',
    newPwd: '新密码',
    sercurity: '安全设置',
    download: '下载',
    minute: '分',
    hour: '时',
    day: '天',
    month: '月',
    week: '周',
    today: '今天',
    yesterday: '昨天',
    aWeekAgo: '一周前',
    close: '关闭',
    newVal: '新数据',
    oldVal: '旧数据',
    label: '标签名称',
    content: '内容',
    chgDetails: '变更详情',
    reloadLic: '重新加载许可证',
    remark: '备注',
    reject: '拒绝',
    color: '颜色',
    upload: '上传',
    uploadClick: '点击上传',
    uploadMax: '超过文件上传的最大个数',
    uploadDrag: '将文件拖到此处，或',
    uploadFormatError: '文件格式不正确，请重新上传',
    uploadImg: '文件格式错误，请上传图片类型,如:JPG，PNG后缀的文件',
    uploadMaxSize: '上传文件大小超过限制',
    downTmpl: '下载模板',
    xlsOrXlsx: '仅允许导入“xls”或“xlsx”格式文件！',
    removeConfirm: '确定移除',
    chgFileDown: '变更文件下载',
    Mon: '星期一',
    Tues: '星期二',
    Wed: '星期三',
    Thur: '星期四',
    Fri: '星期五',
    Sat: '星期六',
    Sun: '星期日',
    total: '显示总数',
    mandatory: '必输',
    allowValue: '允许值',
    txt: '仅允许导入“txt”格式文件',
    expExcel: '导出Excel文件',
    //Camera
    noFrontCamera: "您的设备上似乎没有前置摄像头",
    noRearCamera: "您的设备上似乎没有后置摄像头",
    startDate: '开始日期',
    endDate: '结束日期',
    noticeUnit: '需要通知的部门',
    help: "帮助",
    variable: "变量"
  },
  http: {
    401: '未授权',
    404: '页面不存在',
    500: '系统内部错误'
  },
  valid: {
    required: '必须填写',
    number: '必须为数字值',
    addSearch: '请添加查询条件',
    sameSearch: '该字段已经存在相同比较符的条件，请勿重复添加',
    nonChgView: '当前视图无任何变更，无需保存！',
    selColumn: '至少选择一列',
    addView: '还有视图未保存，是否新增视图？',
    saveView: '确定要保存当前视图的操作？',
    selected: '至少选择一个选项',
    unitGrp: '部门组和部门必须有一个要选择',
    unit: '部门至少要选择一个',
    cpwd: '请再次输入密码',
    ncpwd: '两次输入密码不一致',
    email: '请输入有效的邮箱地址',
    mobile: '请输入正确的手机号',
    selRole: '角色必须选择',
    rqlang: '字典语言和字典值必须填写',
    dblang: '已经存在相同字典语言',
    pwdValidError: '密码必须包括如下内容：',
    length: '长度',
    letters: '字母',
    digits: '数字',
    specialCharracters: '特殊字符',
    containSensitive: '大小写字母',
    selMenu: '菜单必须选择',
    formatErr: '格式不正确',
    trueOrFalse: '值必须为true或false',
    unPerm: '无对应操作权限',
    uploadFile: '请先上传文件',
    selUnitGrp: '至少选择一个部门组',
    extEmpty: '请选择扩展功能',
    extExists: '已存在相同扩展功能',
    extLen: '长度必须小于',
    min: '最小值为：',
    max: '最大值为：',
    range: '请输入一个介于 {0} 和 {1} 之间的数值'
  },
  view: {
    add: '新增视图',
    upd: '修改视图',
    del: '删除视图',
    name: '视图名称',
    column: '视图列',
    confirmDel: '确定要删除当前视图？',
    confirmDefView: '确定要将当前视图设置为默认视图吗？',
    save: '保存视图',
    share: '共享视图',
    defView: '默认视图',
    priView: '私有视图',
    priViewDes: '私有视图仅自己可见',
    pubView: '公有视图',
    pubViewDes: '将此设置为默认的公共视图，所有人可见',
    roleView: '角色视图',
    roleViewDes: '在下面选择相关的角色可以看到的视图'
  },
  oper: {
    eq: '等于',
    ne: '不等于',
    starWith: '开始于',
    endWith: '结束于',
    contains: '包含',
    bigger: '大于',
    less: '小于',
    biggerThan: '大于等于',
    lessThan: '小于等于',
    before: '以前',
    after: '以后',
    lastDay: '最近一天',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    last3Month: '最近三个月',
    last6Month: '最近六个月',
    lastYear: '最近一年',
    no: '不在',
    yes: '在',
    ltToday: '小于今天',
    leToday: '小于等于今天',
    gtToday: '大于今天',
    geToday: '大于等于今天'
  },
  role: {
    add: '新增角色',
    upd: '修改角色',
    view: '查看角色',
    del: '删除角色',
    name: '角色名称',
    desc: '角色描述',
    menu: '菜单选择',
    assignRole: '可分配角色',
    select: '已选角色',
    expEncodeFile: '导出加密文件',
    rtn: '实时检测邮件通知',
    btn: '批量检测邮件通知'
  },
  user: {
    add: '新增用户',
    upd: '修改用户',
    view: '查看用户',
    del: '删除用户',
    resetinf: '密码重置为：'
  },
  unit: {
    add: '新增部门',
    upd: '修改部门',
    view: '查看部门',
    del: '删除部门',
    code: '部门代号',
    desc: '部门名称'
  },
  codeDtl: {
    add: '新增参数',
    upd: '修改参数',
    view: '查看参数',
    del: '删除参数',
    refMasterCode: '主代码',
    refCode: '代码',
    refDesc: '描述'
  },
  unitGrp: {
    add: '新增部门组',
    upd: '修改部门组',
    view: '查看部门组',
    del: '删除部门组',
    name: '部门组名称',
    desc: '部门组描述',
    exp1: 'EXP',
    assignUnitGrp: '可选部门组',
    selectUnitGrp: '已选部门组',
    assignUnit: '可选部门',
    selectUnit: '已选部门'
  },
  dic: {
    add: '新增字典',
    upd: '修改字典',
    del: '删除字典',
    view: '查看字典',
    hkey: '字典名称',
    pkey: '父级字典',
    code: '代码',
    desc: '描述'
  },
  cron: {
    add: '新增任务',
    upd: '修改任务',
    del: '删除任务',
    view: '查看任务',
    hkey: '任务名称',
    func: '功能描述',
    executeTime: 'Cron执行表达式',
    execStatus: '执行状态',
    concurrent: '允许并发',
    lastExecDate: '最后执行时间',
    nextExecDate: '下一执行时间',
    lastRunResult: '最后执行结果',
    ap1: ', - * /',
    ap2: ', - * ? / L',
    ap3: ', - * ? / L #',
    sp1: '使用星号(*) 指示着你想在这个域上包含所有合法的值。例如，在月份域上使用星号意味着每个月都会触发这个 trigger。表达式样例：0 * 17 * * ?意义：每天从下午5点到下午5:59中的每分钟激发一次 trigger。',
    sp2: '问号只能用在日和周域上，但是不能在这两个域上同时使用。你可以认为 ? 字符是 "我并不关心在该域上是什么值。" 这不同于星号，星号是指示着该域上的每一个值。? 是说不为该域指定值。表达式样例：0 10,44 14 ? 3 WEB意义：在三月中的每个星期三的下午 2:10 和 下午 2:44 被触发。',
    sp3: '逗号 (,) 是用来在给某个域上指定一个值列表的。例如，使用值 0,15,30,45 在秒域上意味着每15秒触发一个 trigger。',
    sp4: '斜杠 (/) 是用于时间表的递增的。表达式样例：0/15 0/30 * * * ?意义：在整点和半点时每15秒触发 trigger。',
    sp5: '中划线 (-) 用于指定一个范围。表达式样例：0 45 3-8 ? * *意义：在上午的3点至上午的8点的45分时触发 trigger。',
    sp6: '说明了某域上允许的最后一个值。它仅被日和周域支持。当用在日域上，表示的是在月域上指定的月份的最后一天。表达式 0 0 8 L * ? 意义是在每个月最后一天的上午 8:00 触发 trigger。在月域上的 * 说明是 "每个月"。',
    sp7: '字符(#)仅能用于周域中。它用于指定月份中的第几周的哪一天。例如，如果你指定周域的值为 6#3，它意思是某月的第三个周五 (6=星期五，#3意味着月份中的第三周)。另一个例子 2#1 意思是某月的第一个星期一 (2=星期一，#1意味着月份中的第一周)。注意，假如你指定 #5，然而月份中没有第 5 周，那么该月不会触发。'
  },
  atlog: {
    view: '查看审计日志',
    operTime: '操作日期',
    operHost: '操作主机',
    permission: '功能模块'
  },
  userInfo: {
    avatar: '修改头像',
    baseData: '基本资料',
    updUserData: '用户信息',
    updUserPwd: '用户密码控制'
  },
  mailSuccess: {
    notice1: '邮件发送成功',
    notice2: '　　系统已将重置密码的链接安全的发送到你的邮箱 ',
    notice3: ' ，请及时查收。并在 24 小时内完成重置密码操作。',
    notice4: '　　还没有收到邮件？点击 [ ',
    notice5: '找回密码',
    notice6: ' ] 重试。'
  },
  msgTmpl: {
    add: '新增消息模板',
    upd: '修改消息模板',
    view: '查看消息模板',
    hdrKey: '模板类型',
    defFlag: '是否为默认',
    tmplTitle: '模板标题',
    tmplContent: '模板内容'
  },
  alertMsg: {
    add: '新增系统通知',
    del: '删除系统通知',
    upd: '修改系统通知',
    view: '查看系统通知'
  },
  holiday: {
    info: '假日详情',
    hdate: '日期',
    isHoliday: '是否假期',
    hdateDesc: '描述',
    addArrange: '新增假日安排',
    updArrange: '修改假日安排',
    add: '新增假日',
    upd: '修改假日',
    holiday: '假日',
    workingDay: '工作日',
    toVoid: '作废',
    countryCode: '国家/地区',
    startDate: '开始日期',
    endDate: '结束日期',
    selectMonth: '选择月',
    nonselected: '请先选择国家/地区代码或日期范围',
    weekend: '周末'
  },
  userLogin: {
    add: '新增登录控制',
    upd: '修改登录控制',
    view: '查看登录控制',
    byDay: '按天',
    byWeekend: '按周',
    nonselected: '请勾选周期',
  },
  mclient: {
    add: '新增客户信息',
    upd: '修改客户信息',
    view: '查看客户信息',
    lyodsVersion: '版本号',
    onlyKey: "仅允许导入“key”格式文件！",
    company: '公司',
    site: '城市',
    project: '项目名称',
    platform: '操作系统',
    func: '功能模块',
    maxUser: '最大在线用户数',
    expiration: '有效日期',
    licInfo: '证书信息',
    logo: '客户标识',
    sysInfo: '系统信息',
    updSysInfo: '系统信息维护',
  },
  apiKeys: {
    add: '新增API密钥',
    del: '删除API密钥',
    upd: '修改API密钥',
    view: '查看API密钥',
    create: '创建 UUID',
    illegalChar: '不允许有特殊字符',
  },
  decStates: {
    add: '新增状态',
    upd: '修改状态',
    del: '删除状态',
    view: '查看状态'
  },
  project: {
    add: '新增项目信息',
    upd: '修改项目信息',
    del: '删除项目信息',
    view: '查看项目信息',
    inputNative: "请输入中文内容",
    inputEn: "请输入英文内容",
    contentNative: '中文内容',
    contentEn: '英文内容',
    minAmt: '最小金额',
    donateTypeDic: '支持方式字典',
    ticketFlag: '涉及门票',
    donateTypeFlag: '显示支持方式',
    maxTicket: '最大票数',
    briefForm: '简洁表单',
    dinfoExtExist: '该项目已在捐款记录中被引用,取消涉及门票和显示支持方式将会删除对应捐款记录部分数据',
    workshop: '研讨会',
  },
  donate: {
    add: '新增记录',
    upd: '修改记录',
    view: '查看记录',
    pjId: '捐款项目',
    nameEn: '英文姓名',
    nameNative: '中文姓名',
    alias: '別名',
    gender: '性別',
    telephone: '电话',
    mobile: '移动电话',
    email: '电邮',
    address: '邮寄地址',
    dnMethods: '捐款方法',
    currency: '币种',
    amount: '金额',
    valDate: '捐款日期',
    status: '确认状态',
    refNo: '参考号',
    submitIp: 'IP地址',
    referrer: '推荐人',
    certificate: '捐款凭证',
    confirm: '确认',
    repeat: '重复',
    invalid: '无效',
    refNoNoNull: '确认时需填写银行参考号',
    donateType: '支持方式',
    ticketType: '出席方式',
    ticketSeq: '票号',
    ticketCode: '门票二维码',
    ticketCheckin: '门票是否已检录',
    ticketChkchop: '检录时间及用户',
  },
  uheart: {
    selLang: '选择语言',
    project: '项目',
    register: '捐款登记',
    recentDonates: '近期捐款记录',
    statistics: '捐款统计信息',
    info: '捐款资料',
    formTitle: '捐款/赞助表格',
    formTitle1: '捐助项目',
    formTitle2: '捐助人/机构资料',
    formTitle3: '捐款方法',
    formSubtitle: '本人捐助登记',
    dnMethods: '银行直接存款/自动柜员机转账',
    upload: '上传付款记录',
    uploadTips: '只能上传 jpg / png 文件',
    uploadFormatErr: '上传文件只能是图片格式!',
    uploadRequired: '必须上传付款记录',
    submit: '提交',
    allEvents: '所有活动',
    note: '捐款流程注意事项：',
    tips: '阁下之捐款需经本会确认后方为有效。如有问题，本会将透过电话或电邮联络。',
    refTaxTips: '捐款HK$100或以上者，均可获发收据，作扣税用途。 收据姓名须根据身份证或护照填写中文或英文全名。 如需收据，请填写邮寄地址。',
    point: '联系人',
    phone: '联系电话',
    email: '联系邮箱',
    events: '最新活动',
    title: '研讨会登记',
    capture: '截屏',
    onsite: '现场',
    webinar: '网络',
    leftTicket: '剩余票数',
    send: '提交',
    ticketType: '参与方式',
  },
  ticket: {
    check: '检录',
    total: '门票总数',
    startDate: '开始时间',
    checkCount: '已检录数',
    uncheckCount: '未检录数',
    history: '检录历史',
    qrCode: '二维码',
    welcome: '欢迎！',
    invalid: '确认通知书编码格式不正确',
    view: '查看门票检录'
  },
  emailLog: {
    view: '查看邮件日志',
  },
}

export default zhCN



// WEBPACK FOOTER //
// ./src/assets/lang/zh_CN.js